import '../common/MedDevice.css'
import { useEffect, useMemo, useRef, useState } from "react"
import { Box } from "@mui/material"
import { medicationIcon } from "../../../../icons"
import { useAppDispatch } from "../../../../redux/store"
import PageHeader from "../../../../components/PageHeader"
import { getMedications } from "../../../../services/medsDevicesService"
import { Medication } from "../../../corp/medications/types"
import { addError } from "../../../../redux/alerts"
import constants from "../../../../constants"
import { trackPromise } from 'react-promise-tracker'
import useCustomerNumber from '../../../../hooks/useCustomerNumber'
import useCustomer from '../../../../hooks/useCustomer'
import SalesPage from '../common/SalesPage'
import MedsDevicesContainer from '../common/MedsDevicesContainer'
import { LoadingState } from '../../../../types'
import { KitType } from '../common/enums'

const Medications = () => {
  const dispatch = useAppDispatch()
  const contentRef = useRef<HTMLDivElement>(null)

  const customer = useCustomer()
  const customerNumber = useCustomerNumber()

  const [medications, setMedications] = useState<Medication[]>([])
  const [loading, setLoading] = useState<LoadingState>(LoadingState.NotStarted)

  const compliance = useMemo(() => {
    if (!customer.customerMetadata) return null;

    return {
      message_long: customer.customerMetadata.kit_message_long,
      compliance_status: customer.customerMetadata.medication_status,
    }
  }, [customer.customerMetadata])

  useEffect(() => {
    if (customerNumber) {
      trackPromise(fetchMedications(customerNumber))
    }
  }, [customerNumber])

  const fetchMedications = async (customerNumber: string) => {
    try {
      setLoading(LoadingState.Loading)

      const medications: Medication[] = await getMedications(customerNumber)

      setMedications(medications)
      setLoading(LoadingState.Done)
    } catch (err) {
      console.error(err)
      dispatch(addError('Could not get Kits, please try again later.'))
      setLoading(LoadingState.Error)
    }
  }

  return (
    <Box ref={contentRef}>
      <PageHeader src={medicationIcon} headerName="Medications" />
      {
        Boolean(medications.length) && loading === LoadingState.Done && (
          <MedsDevicesContainer
            type={KitType.Device}
            items={medications}
            header="Kits"
            label="Medications"
            image="chart-medication"
            compliance={compliance}
            contentRef={contentRef}
            fetchItems={fetchMedications}
          />
        )
      }
      {
        medications.length === 0 && loading === LoadingState.Done && (
          <SalesPage
            src={constants.MEDICATIONS_SALES_PAGE_URL}
            title="Emergency Medical Kits"
          />
        )
      }
    </Box>
  )
}

export default Medications